/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'handlebar',
  standalone: true,
})
export class HandlebarPipe implements PipeTransform {
  transform(template: string, context?: { [key: string]: any }, requiredFields?: string[]): string {
    if (!context) {
      return template;
    }
    // Use [^{}]+ to prevent ReDoS: disallow both opening and closing braces inside template variables
    return template.replace(/\{\{([^{}]+)\}\}/g, (match: any, p1: any) => {
      const keys = p1.trim().split();
      let value = context;
      for (const key of keys) {
        if (value && key in value) {
          value = value[key];
        } else if (requiredFields?.includes(key)) {
          return match;
        } else if (key === 'count') {
          return '0';
        } else {
          return '-';
        }
      }
      return value;
    });
  }
}
